import { Link } from 'react-router-dom';
import SEOHead from '@/components/feature/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import FAQ from '@/components/feature/FAQ';
import ScrollToTop from '@/components/feature/ScrollToTop';
export default function AboutPage() {
  const jsonLdOrg = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '八仔漫画网',
    url: 'https://bazaimanhua.com',
    description: '八仔漫画网致力于为广大漫画爱好者提供优质的在线免费漫画阅读体验。',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+86-10-8888-8888',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
    address: {
      '@type': 'PostalAddress',
      addressLocality: '北京',
      addressRegion: '北京',
      addressCountry: 'CN',
    },
  };

  const jsonLdFaq = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      { '@type': 'Question', name: '八仔漫画网需要付费吗？', acceptedAnswer: { '@type': 'Answer', text: '不需要！八仔漫画网所有漫画均免费在线阅读，无需任何付费，我们致力于为广大漫画爱好者提供纯净免费的阅读环境。' } },
      { '@type': 'Question', name: '网站有广告吗？', acceptedAnswer: { '@type': 'Answer', text: '八仔漫画网采用纯净阅读模式，无弹窗广告、无插屏广告、无视频广告，让您全身心沉浸在漫画的世界中。' } },
      { '@type': 'Question', name: '漫画多久更新一次？', acceptedAnswer: { '@type': 'Answer', text: '我们每日更新漫画内容，根据各漫画的连载进度同步更新，确保您可以第一时间阅读到最新章节。' } },
      { '@type': 'Question', name: '如何找到我想看的漫画？', acceptedAnswer: { '@type': 'Answer', text: '您可以通过首页的分类导航浏览不同类型漫画，也可以使用搜索功能直接查找您喜欢的漫画作品。我们还提供热门推荐和评分排行，帮您发现更多优质漫画。' } },
      { '@type': 'Question', name: '可以在手机上阅读吗？', acceptedAnswer: { '@type': 'Answer', text: '当然可以！八仔漫画网已适配手机、平板等多种设备，无论您使用什么设备，都能获得流畅舒适的阅读体验。' } },
    ],
  };

  const faqItems = [
    { question: '八仔漫画网需要付费吗？', answer: '不需要！八仔漫画网所有漫画均免费在线阅读，无需任何付费，我们致力于为广大漫画爱好者提供纯净免费的阅读环境。' },
    { question: '网站有广告吗？', answer: '八仔漫画网采用纯净阅读模式，无弹窗广告、无插屏广告、无视频广告，让您全身心沉浸在漫画的世界中。' },
    { question: '漫画多久更新一次？', answer: '我们每日更新漫画内容，根据各漫画的连载进度同步更新，确保您可以第一时间阅读到最新章节。' },
    { question: '如何找到我想看的漫画？', answer: '您可以通过首页的分类导航浏览不同类型漫画，也可以使用搜索功能直接查找您喜欢的漫画作品。我们还提供热门推荐和评分排行，帮您发现更多优质漫画。' },
    { question: '可以在手机上阅读吗？', answer: '当然可以！八仔漫画网已适配手机、平板等多种设备，无论您使用什么设备，都能获得流畅舒适的阅读体验。' },
  ];

  return (
    <>
      <SEOHead
        title="关于我们 - 八仔漫画网 - 免费在线漫画阅读平台"
        description="八仔漫画网致力于为广大漫画爱好者提供优质的在线免费漫画阅读体验。无需付费，无广告干扰，纯净阅读环境，每日更新海量精品漫画。"
        keywords="八仔漫画网,关于我们,免费漫画,在线漫画,漫画平台"
        canonicalUrl="https://bazaimanhua.com/about"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLdOrg) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLdFaq) }}
      />
      <ScrollToTop />
      <Navbar />
      <main className="min-h-screen">
        <div className="bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <Breadcrumb
              items={[
                { label: '首页', to: '/' },
                { label: '关于我们' },
              ]}
            />
          </div>
        </div>

        <section className="py-14 md:py-18" aria-label="品牌介绍">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="max-w-3xl mx-auto text-center mb-12">
              <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
                关于八仔漫画网
              </h1>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                八仔漫画网是一个专注于漫画在线阅读的优质平台，致力于为每一位漫画爱好者提供<strong>无需付费、无广告干扰</strong>的纯净阅读环境。
                我们收录了海量精品国漫、日漫等资源，涵盖热血、恋爱、玄幻、搞笑、悬疑、科幻等多种类型，每日更新，让您随时随地畅享漫画的乐趣。
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-14">
              <div className="bg-background-50 rounded-lg border border-background-200 p-6 text-center">
                <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-shield-check-line text-primary-600 text-2xl"></i>
                </div>
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-2">纯净阅读</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  无弹窗广告、无插屏广告，为您提供最纯净的漫画阅读体验，让阅读回归本质。
                </p>
              </div>
              <div className="bg-background-50 rounded-lg border border-background-200 p-6 text-center">
                <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-book-open-line text-accent-600 text-2xl"></i>
                </div>
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-2">海量资源</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  收录超过1000部精品漫画，涵盖多种类型和风格，满足不同读者的阅读口味和需求。
                </p>
              </div>
              <div className="bg-background-50 rounded-lg border border-background-200 p-6 text-center">
                <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-secondary-100">
                  <i className="ri-refresh-line text-secondary-600 text-2xl"></i>
                </div>
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-2">每日更新</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  紧跟漫画连载进度，每日同步更新最新章节，让您第一时间追更喜欢的漫画作品。
                </p>
              </div>
            </div>

            <div className="bg-background-100 rounded-lg p-6 md:p-10 mb-14">
              <div className="max-w-3xl mx-auto">
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 text-center mb-6">
                  我们的使命
                </h2>
                <div className="relative">
                  <div className="absolute -top-2 -left-2 text-6xl text-primary-200 opacity-50 leading-none font-serif">"</div>
                  <p className="text-sm md:text-base text-foreground-600 leading-relaxed relative z-10 text-center px-4">
                    在快节奏的现代生活中，我们相信每个人都应该拥有一个可以放松心灵的空间。八仔漫画网就是这样一个地方——
                    一个没有广告打扰、无需付费、纯粹享受漫画乐趣的田园。我们希望通过优质的内容和舒适的阅读体验，
                    让漫画爱好者能够随时随地开启一段精彩的漫画之旅。
                  </p>
                  <div className="absolute -bottom-8 -right-2 text-6xl text-primary-200 opacity-50 leading-none font-serif rotate-180">"</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-18 bg-background-100" aria-label="用户口碑">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">用户口碑</h2>
              <p className="text-sm text-foreground-500 mt-1">听听漫画爱好者们怎么说</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {[
                { name: '小明', role: '大学生', comment: '八仔漫画网真的太棒了！完全没有广告打扰，阅读体验超级好。我每天都会来看《伪装学渣》的更新，强推给大家！', rating: 5 },
                { name: '漫画迷小王', role: '上班族', comment: '找了好久才找到这么一个纯净的漫画网站。分类很全，更新也快，上班摸鱼看漫画的首选！', rating: 5 },
                { name: '二次元爱好者', role: '设计师', comment: '网站设计简洁好看，没有乱七八糟的广告。漫画资源很丰富，国漫日漫都有，爱了爱了！', rating: 5 },
              ].map((review, index) => (
                <div key={index} className="bg-background-50 rounded-lg border border-background-200 p-5">
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: review.rating }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">"{review.comment}"</p>
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
                      <span className="text-xs font-bold text-primary-600">{review.name[0]}</span>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-900">{review.name}</p>
                      <p className="text-xs text-foreground-500">{review.role}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-14 md:py-18" aria-label="联系我们">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="max-w-2xl mx-auto">
              <div className="text-center mb-8">
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">联系我们</h2>
                <p className="text-sm text-foreground-500 mt-1">有任何问题或建议，欢迎随时联系我们</p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-10">
                <div className="text-center p-4 bg-background-50 rounded-lg border border-background-200">
                  <div className="w-10 h-10 mx-auto mb-2 flex items-center justify-center rounded-full bg-primary-100">
                    <i className="ri-mail-line text-primary-600"></i>
                  </div>
                  <p className="text-xs text-foreground-500 mb-1">电子邮箱</p>
                  <p className="text-sm font-medium text-foreground-900">contact@bazaimanhua.com</p>
                </div>
                <div className="text-center p-4 bg-background-50 rounded-lg border border-background-200">
                  <div className="w-10 h-10 mx-auto mb-2 flex items-center justify-center rounded-full bg-accent-100">
                    <i className="ri-customer-service-2-line text-accent-600"></i>
                  </div>
                  <p className="text-xs text-foreground-500 mb-1">在线客服</p>
                  <p className="text-sm font-medium text-foreground-900">工作日 9:00-18:00</p>
                </div>
                <div className="text-center p-4 bg-background-50 rounded-lg border border-background-200">
                  <div className="w-10 h-10 mx-auto mb-2 flex items-center justify-center rounded-full bg-secondary-100">
                    <i className="ri-map-pin-line text-secondary-600"></i>
                  </div>
                  <p className="text-xs text-foreground-500 mb-1">公司地址</p>
                  <p className="text-sm font-medium text-foreground-900">中国北京市朝阳区</p>
                </div>
              </div>

              <form
                className="bg-background-100 rounded-lg border border-background-200 p-6"
                id="about-contact-form"
                data-readdy-form="true"
                action="https://readdy.ai/api/form/d9pcn58senbniolessug"
                method="POST"
              >
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                  <div>
                    <label htmlFor="contact-name" className="block text-xs font-medium text-foreground-700 mb-1">姓名</label>
                    <input
                      type="text"
                      id="contact-name"
                      name="name"
                      required
                      className="w-full px-4 py-2.5 bg-background-50 border border-background-200 rounded-lg text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-400 transition-colors"
                      placeholder="请输入您的姓名"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-email" className="block text-xs font-medium text-foreground-700 mb-1">邮箱</label>
                    <input
                      type="email"
                      id="contact-email"
                      name="email"
                      required
                      className="w-full px-4 py-2.5 bg-background-50 border border-background-200 rounded-lg text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-400 transition-colors"
                      placeholder="请输入您的邮箱"
                    />
                  </div>
                </div>
                <div className="mb-4">
                  <label htmlFor="contact-message" className="block text-xs font-medium text-foreground-700 mb-1">留言</label>
                  <textarea
                    id="contact-message"
                    name="message"
                    required
                    maxLength={500}
                    rows={4}
                    className="w-full px-4 py-2.5 bg-background-50 border border-background-200 rounded-lg text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-400 transition-colors resize-none"
                    placeholder="请输入您的留言（500字以内）"
                  ></textarea>
                </div>

                <div className="honeypot-wrapper" aria-hidden="true">
                  <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" readOnly />
                </div>

                <button
                  type="submit"
                  className="w-full py-3 bg-primary-500 text-background-50 rounded-lg font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  提交留言
                </button>
                <p className="text-xs text-foreground-500 text-center mt-3">
                  提交即表示您同意我们的隐私政策和服务条款
                </p>
              </form>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-18 bg-background-100" aria-label="常见问题">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <div className="text-center mb-8">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">常见问题</h2>
              <p className="text-sm text-foreground-500 mt-1">关于八仔漫画网的常见疑问解答</p>
            </div>
            <FAQ items={faqItems} />
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}